import { ReactElement } from 'react'
import { AuthProvider } from './hooks/auth'
import { CookiesProvider } from 'react-cookie';
import { GoalContextContextProvider } from './hooks/goal';
import { DateContextContextProvider } from './hooks/date';
import { LoaderContextContextProvider } from './hooks/loading';
import { SWRConfig } from 'swr'
import { BdWebComponentsProvider } from 'bd-web-components';

interface ProviderProps {
  children: ReactElement
  theme?: any
}

export default function Providers(props: ProviderProps): ReactElement {
  return (<BdWebComponentsProvider>
    <SWRConfig
      value={{
        refreshInterval: 60000,
        fetcher: (resource, init) => fetch(resource, init).then(res => res.json())
      }}
    >
      <LoaderContextContextProvider>
        <GoalContextContextProvider>
          <DateContextContextProvider>
            <CookiesProvider>
              <AuthProvider>
                {props.children}
              </AuthProvider>
            </CookiesProvider>
          </DateContextContextProvider>
        </GoalContextContextProvider>
      </LoaderContextContextProvider>
    </SWRConfig>
  </BdWebComponentsProvider>)
}
